import React, { Component } from 'react';
import {Nav} from 'reactstrap';
import PropTypes from 'prop-types';

import { AppSidebarToggler } from '@coreui/react';
import { Button } from 'reactstrap'
import {doLogout} from '../../js/firebase/firebase-auth'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class FullHeader extends Component {
  render() {
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <div className="navbar-brand">
          <h5>Migração Astrea</h5>
        </div>
        <AppSidebarToggler className="d-md-down-none" display="lg" />
        <Nav className="ml-auto" navbar>
          <Button color="link" onClick={doLogout}><i className="fa fa-sign-out"></i></Button>
        </Nav>
      </React.Fragment>
    );
  }
}

FullHeader.propTypes = propTypes;
FullHeader.defaultProps = defaultProps;

export default FullHeader;



// WEBPACK FOOTER //
// ./src/containers/Full/FullHeader.js